import { getAxiosClient } from "../../axios-client";
import {
  ShowPotentialWarehousesRequestBody,
  ShowPotentialWarehousesResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const showPotentialWarehouses = async (
  body: ShowPotentialWarehousesRequestBody
) => {
  return await axiosClient.ax.post<ShowPotentialWarehousesResponse>(
    "/Offers/ShowPotentialWarehousesForGenerationOfferManually",
    body
  );
};
